<component :is="comp" :icon-class="iconClass" :field-name="fieldName"></component>